

















import Vue from "vue";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "ExtendTrial",
  components: {},
  props: {
    account: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      datePickerOptions: {
        disabledDate(date) {
          return date < Date.now();
        },
      },
      trialModel: {
        expiredDate: null,
      },
      trialModelRules: {
        expiredDate: [
          {
            type: "date",
            required: true,
            message: "Please pick a data",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    showModal(): any {
      return this.showEditor;
    },
  },
  watch: {
    showModal(newVal) {
      let context = this as any;
      if (newVal === true) {
        context.trialModel = {
          expiredDate: new Date(this.account.endDate),
        };
      }
    },
  },
  mounted() {
    let context = this;
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.SetupForm as any;

      form.validate((valid: boolean) => {
        if (valid) {
          let context = this;
          context.$store
            .dispatch("billing/extendFreeTrial", { data: { accountId: context.account.id, endDate: context.trialModel.expiredDate } })
            .then((response) => {
              if (response.data.result.success === true) {
                context.$Notice.success({
                  title: "Extend trial end date",
                  desc: "Success! ",
                });

                this.$emit("cancel");
              } else {
                context.$Modal.error({
                  title: "Oops!",
                  content: response.data.result.errorMessage,
                });
              }
            })
            .finally(() => {
              target.disabled = false;
            });
        }
      });
    },
  },
});
